import { useCallback } from 'react';

import { ImagePromotion as ImagePromotionInterface } from '@interfaces';
import { useTheme } from '@utilities';

export interface ImagePromotionProps extends ImagePromotionInterface {}

function useImagePromotion({ columns, blockTheme }: Partial<ImagePromotionProps>) {
  const theme = useTheme({ blockTheme });

  const getGridColumns = useCallback((): string => {
    if (columns === 2) return 'md:grid-cols-2';
    if (columns === 3) return 'lg:grid-cols-3';
    if (columns === 4) return 'md:grid-cols-2 lg:grid-cols-4';
    if (columns === 5) return 'md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5';
    if (columns === 6) return 'grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6';
    if (columns === 7) return 'grid-cols-3 lg:grid-cols-4 2xl:grid-cols-7';
    if (columns === 8) return 'grid-cols-3 lg:grid-cols-4 2xl:grid-cols-8';
    return '';
  }, [columns]);

  const gridColumns = getGridColumns();

  return {
    theme,
    gridColumns,
  };
}

export default useImagePromotion;
